<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label class="digm-form-required">Type</label>
              </b-col>
              <b-col sm="9">
                <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options" class="mb-3" />
              </b-col>
            </b-row>
          </div>
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label class="digm-form-required">Branch</label>
              </b-col>
              <b-col sm="9">
                <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <div v-if="branch_validate">
                    <span class="error">The Branch field is required.</span>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <template v-if="formType === 'starterPack'">
          <form @submit.prevent="validateSubmit('starterPack')" data-vv-scope="starterPack">
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label class="digm-form-required">Member ID</label>
                  </b-col>
                  <b-col sm="9">
                    <div class="custom-search-select">
                      <model-select
                        autocomplete="false"
                        @searchchange="searchMemberWithoutBranch"
                        :options="optionsMember"
                        class="border-bottom"
                        name="member_id"
                        v-validate="'required'"
                        v-model="addData.member_id"
                      ></model-select>
                    </div>
                    <span class="error">{{ errors.first('starterPack.member_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Member Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="fullNameDetail" type="text"></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6"></div>
            </div>
            <hr class="mt-20">
            <div class="mb-10">
              <div class="row">
                <div class="col-sm-6">
                  <div>Product List</div>
                </div>
                <div class="col-sm-6 text-right">
                  <a @click="addRow" class="btn-grey"><i class="fas fa-plus-square mr-5"></i>Add Product</a>
                </div>
              </div>
              <hr class="short-line left mb-20">
              <table class="w-100">
                <thead>
                  <tr>
                    <th style="width: auto;">Product</th>
                    <th style="width: 140px;">Stock</th>
                    <th style="width: 160px;">Quantity</th>
                    <th style="width: 50px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in rows" :key="index">
                    <td>
                      <b-form-select class="border-bottom" v-model="row.product_id" @change="onProductChange(index)">
                        <option :value="null">Please select</option>
                        <option v-for="item in itemsProduct" :key="item.id" :value="item.id">{{item.name}}</option>
                      </b-form-select>
                    </td>
                    <td>
                      <template v-if="row.product_id != null">
                        <span :class="{'color-red': isInsufficient(row)}">{{stockFor(row.product_id)}}</span>
                      </template>
                    </td>
                    <td>
                      <b-form-spinbutton v-model="row.quantity" min="1" max="999"></b-form-spinbutton>
                      <div v-if="isInsufficient(row)">
                        <span class="error">Stock tidak cukup (sisa: {{stockFor(row.product_id)}})</span>
                      </div>
                    </td>
                    <td>
                      <a v-if="rows.length > 1" @click="removeRow(index)" class="color-red">
                        <i class="fas fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-right mt-20">
              <button type="submit" class="btn-primary">Submit</button>
            </div>
          </form>

          <hr class="mt-30">
          <div class="mb-10">
            <div>History</div>
            <hr class="short-line left mb-20">
            <b-table :hover="true" :striped="true" responsive="sm" :items="historyItems" :fields="historyFields">
              <template v-slot:cell(member)="data">
                <template v-if="data.item.member">{{data.item.member.first_name}} {{data.item.member.last_name}}</template>
              </template>
              <template v-slot:cell(product)="data">
                <template v-if="data.item.grab_and_go_product">{{data.item.grab_and_go_product.name}}</template>
              </template>
              <template v-slot:cell(date)="data">
                {{parseDate(data.item.created_at)}}
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="historyCurrentPage"
                :total-pages="historyTotalPage"
                @page-changed="historyPageChanged"
                prev-text="Prev" next-text="Next"/>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import moment from 'moment'
import { Auth } from '@/api'
import Mixin from '../../mixins/memberMixin'
import { ModelSelect } from 'vue-search-select'
import Pagination from '@/views/component/pagination'

export default {
  name: 'addStarterPack',
  mixins: [Mixin],
  components: {
    ModelSelect,
    'app-pagination': Pagination
  },
  data: function () {
    return {
      dataBranch: [],
      branch_validate: false,
      optionsMember: [{ value: null, text: 'Please select' }],
      itemsProduct: [],
      stockMap: {},
      fullNameDetail: '',
      detailMember: {},
      formType: 'starterPack',
      historyItems: [],
      historyFields: [
        { key: 'member', label: 'Member' },
        { key: 'branch.name', label: 'Branch' },
        { key: 'product', label: 'Product' },
        { key: 'quantity', label: 'Quantity' },
        { key: 'date', label: 'Date' }
      ],
      historyCurrentPage: 1,
      historyPaginationLimit: 10,
      historyTotalPage: 0,
      options: [
        { value: null, text: 'Please select' },
        { value: 'freeze', text: 'Freeze' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'outstanding', text: 'Outstanding' },
        { value: 'wristband', text: 'Wristband' },
        { value: 'lostAndFound', text: 'Lost & Found' },
        { value: 'dailyVisit', text: 'Daily Visit' },
        { value: 'grabAndGo', text: 'Grab & Go' },
        { value: 'grabAndGoGopay', text: 'Grab & Go Gopay' },
        { value: 'extendPt', text: 'Extend PT' },
        { value: 'corporateOutstanding', text: 'Corporate Invoice Outstanding' },
        { value: 'merchandise', text: 'Merchandise' },
        { value: 'starterPack', text: 'Starter Pack' }
      ],
      addData: {
        branch_id: null,
        member_id: null
      },
      rows: [
        { product_id: null, quantity: 1 }
      ]
    }
  },
  methods: {
    parseDate (value) {
      moment.locale('en')
      return moment(value).format('DD MMMM YYYY, h:mm a')
    },
    historyPageChanged (pageNum) {
      this.historyCurrentPage = pageNum
      this.fetchHistory()
    },
    fetchHistory () {
      var url = 'crm/v1/form_member_starter_pack?page=' + this.historyCurrentPage + '&limit=' + this.historyPaginationLimit
      axios.get(url).then(response => {
        this.historyItems = response.data.data.rows
        this.historyTotalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeFormType (event) {
      if (event === 'freeze') {
        this.$router.push('/allForm/addFreeze')
      } else if (event === 'cancel') {
        this.$router.push('/allForm/addCancel')
      } else if (event === 'outstanding') {
        this.$router.push('/allForm/addOutstanding')
      } else if (event === 'wristband') {
        this.$router.push('/allForm/addWristband')
      } else if (event === 'lostAndFound') {
        this.$router.push('/allForm/addLostAndFound')
      } else if (event === 'dailyVisit') {
        this.$router.push('/allForm/addDailyVisit')
      } else if (event === 'grabAndGo') {
        this.$router.push('/allForm/addGrabAndGo')
      } else if (event === 'grabAndGoGopay') {
        this.$router.push('/allForm/addgrabAndGoGopay')
      } else if (event === 'corporateOutstanding') {
        this.$router.push('/allForm/addCorporateOutstanding')
      } else if (event === 'extendPt') {
        this.$router.push('/allForm/addExtendPt')
      } else if (event === 'merchandise') {
        this.$router.push('/allForm/addMerchandise')
      } else if (event === 'starterPack') {
        this.$router.push('/allForm/addStarterPack')
      } else {
        this.$router.push('/allForm/add')
      }
    },
    openPage (event) {
      this.$router.push(event)
    },
    addRow () {
      this.rows.push({ product_id: null, quantity: 1 })
    },
    removeRow (index) {
      this.rows.splice(index, 1)
    },
    stockFor (productId) {
      return this.stockMap[productId] != null ? this.stockMap[productId] : '-'
    },
    isInsufficient (row) {
      if (row.product_id == null || this.stockMap[row.product_id] == null) return false
      return row.quantity > this.stockMap[row.product_id]
    },
    onProductChange () {
      this.refreshStock()
    },
    refreshStock () {
      if (!this.addData.branch_id) return
      var productIds = this.rows.map((r) => r.product_id).filter((id) => id != null)
      if (productIds.length === 0) return
      axios.get('crm/v1/form_member_starter_pack/stock?branch_id=' + this.addData.branch_id + '&product_ids=' + productIds.join(',')).then(response => {
        this.stockMap = Object.assign({}, this.stockMap, response.data.data)
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeBranch (event) {
      this.branch_validate = false
      this.stockMap = {}
      this.refreshStock()
    },
    validateSubmit (data) {
      this.$validator.validateAll(data).then((result) => {
        if (this.addData.branch_id == null) {
          this.branch_validate = true
          this.$toast.success('The Branch field is required!', 'Error', {
            position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
          })
          return
        }

        if (!result) {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
          })
          return
        }

        var validRows = this.rows.filter((r) => r.product_id != null && r.quantity > 0)
        if (validRows.length === 0) {
          this.$toast.success('Add at least one product!', 'Error', {
            position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
          })
          return
        }

        if (validRows.some((r) => this.isInsufficient(r))) {
          this.$toast.success('Stock tidak cukup untuk salah satu product, silakan sesuaikan quantity.', 'Warning', {
            position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(255, 193, 7)',
            theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
          })
          return
        }

        var payload = Object.assign({}, this.addData, {
          product_id: validRows.map((r) => r.product_id),
          quantity: validRows.map((r) => r.quantity)
        })

        axios.post('crm/v1/form_member_starter_pack/', payload).then(() => {
          this.rows = [{ product_id: null, quantity: 1 }]
          this.addData.member_id = null
          this.fetchHistory()
          this.$toast.success('data saved successfully!', 'Success', {
            position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
          })
        }).catch(error => {
          var message = (error.response && error.response.data && error.response.data.message) || 'cant saved data!'
          this.$toast.success(message, 'Warning', {
            position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(255, 193, 7)',
            theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
          })
        })
      })
    },
    fetchData () {
      this.getMemberWithoutBranch()

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows

        if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
          this.dataBranch = this.dataBranch.filter(branch => branch.id == Auth.Session.get().paradigm_branch_id)
        }
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/grab_and_go_product?limit=1000').then(response => {
        this.itemsProduct = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  computed: {
    getMemberId: function () {
      return this.addData.member_id
    }
  },
  watch: {
    getMemberId () {
      axios.get('fitness/v1/member/' + this.addData.member_id).then(response => {
        this.detailMember = response.data.data
        this.fullNameDetail = response.data.data.first_name + ' ' + response.data.data.last_name
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
    this.fetchHistory()

    const roleId = Auth.Session.get().paradigm_role
    if (roleId == 6 || roleId == '6') {
      this.addData.branch_id = Auth.Session.get().paradigm_branch_id
      this.changeBranch()
    }
  }
}
</script>

<style>
</style>
